import { AccessDenied, ContentVariant } from './AccessDenied';

export const InvoicesAccessDenied = (): JSX.Element => (
  <AccessDenied variant={ContentVariant.invoices} />
);

export const BillingAccessDenied = (): JSX.Element => (
  <AccessDenied variant={ContentVariant.billing} />
);

export const SSOAccessDenied = (): JSX.Element => <AccessDenied variant={ContentVariant.sso} />;

export const UserAttributesAccessDenied = (): JSX.Element => (
  <AccessDenied variant={ContentVariant.userAttributes} />
);

export const SubscriptionsAccessDenied = (): JSX.Element => (
  <AccessDenied variant={ContentVariant.subscriptions} />
);
